// extracted by mini-css-extract-plugin
export var actionButton = "_ix-0";
export var fileInput = "_ix-2";
export var paperclip = "_ix-1";